import { ENVIO_API_TOKEN } from '$lib/constants/envioEndpoint';
import { stateEnvioEndpoint } from '$states/envioEndpoint.svelte';
import { log } from '$utils/__log';
import { backOff, type BackoffOptions } from 'exponential-backoff';

const options: BackoffOptions = {
  startingDelay: 1000,
  timeMultiple: 2,
  numOfAttempts: 10,
};

export class APIError extends Error {
  constructor(
    message: string,
    public status?: number,
    public data?: unknown,
  ) {
    super(message);
    this.name = 'APIError';
  }
}

export const executeQuery = async <T>(
  query: string,
  variables: Record<string, unknown>,
  operationName?: string,
): Promise<T> => {
  const response = await backOff(
    () =>
      fetch(stateEnvioEndpoint.current.https, {
        method: 'POST',
        headers: {
          Authorization: `Bearer ${ENVIO_API_TOKEN}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          query,
          variables,
          operationName,
        }),
      }),
    options,
  );

  if (!response.ok) {
    throw new APIError('Query execution failed', response.status);
  }

  const result = (await response.json()) as { data: T; errors: unknown[] };

  if (result.errors) {
    log('GraphQL errors ->', result.errors);
    throw new APIError('GraphQL errors', undefined, result.errors);
  }

  return result.data;
};
